module.exports = __webpack_public_path__ + "img/ic_filter_list.a28b3c5c.svg";